import { memo } from 'react';
import { ArrowRight } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { formatCurrency } from '../../lib/currency';
import type { UnifiedTransfer } from '../../hooks/useTransfers';
import type { CurrencyCode } from '../../types';

interface UnifiedTransferCardProps {
  transfer: UnifiedTransfer;
  currency: CurrencyCode;
}

export const UnifiedTransferCard = memo(function UnifiedTransferCard({
  transfer,
  currency,
}: UnifiedTransferCardProps) {
  return (
    <Card>
      <CardContent className="py-4">
        <div className="flex items-center gap-3">
          <div className="flex-1 min-w-0 text-right">
            <p className="font-medium truncate">{transfer.fromName}</p>
            {transfer.fromIsGroup && (
              <p className="text-xs text-muted-foreground truncate">
                {transfer.fromDisplayName}
              </p>
            )}
          </div>
          <div className="flex flex-col items-center shrink-0">
            <ArrowRight className="h-5 w-5 text-muted-foreground" />
            <span className="text-sm font-semibold text-primary">
              {formatCurrency(transfer.amount, currency)}
            </span>
          </div>
          <div className="flex-1 min-w-0">
            <p className="font-medium truncate">{transfer.toName}</p>
            {transfer.toIsGroup && (
              <p className="text-xs text-muted-foreground truncate">
                {transfer.toDisplayName}
              </p>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
});
